import React from 'react';
import lightningImage from 'assets/images/lightning.png';
import { CloseOutlineIcon } from 'cokitchen-icons';
import { Button } from '@cokitchen/cokitchen-components';

type Props = {
  onIgnore: () => void;
  onRemove: () => void;
};

const QuickeatsBanner = (props: Props) => {
  const { onIgnore, onRemove } = props;

  return (
    <div className='p-2 pt-0 bg-white border-b border-[#EAEBEB]'>
      <div className='flex flex-col gap-4 p-6 rounded-md shadow-lg border border-[#EAEBEB] bg-white'>
        <div className='flex items-start gap-3'>
          <img src={lightningImage} className='w-5 aspect-square' />
          <article className='flex flex-col gap-2 text-sm'>
            <p className='font-semibold'>Heads Up!</p>
            <p className='text-gray-9'>
              Adding other restaurants to your Quick Eats order may increase your preparation time.
            </p>
          </article>
          <button className='scale-125' onClick={onIgnore}>
            <CloseOutlineIcon />
          </button>
        </div>
        <div className='flex items-center gap-3'>
          <Button small variant='block' color='primary' className='grow h-8' onClick={onIgnore}>
            Ignore
          </Button>
          <Button
            small
            variant='outline'
            color='gray'
            className='grow h-8 !border-gray-2 hover:!bg-gray-11'
            onClick={onRemove}>
            Remove other items
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickeatsBanner;
